import * as React from 'react';
import { Box } from '@mui/material';
import { SearchBox } from './search/SearchBox';
import { ClipTable } from './clip/ClipTable';

export const MainPanel = () => {
    return (
        <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            width: '100%',
            gap: { xs: 2, sm: 3 },
        }}>
            <Box sx={{ width: '100%' }}>
                <SearchBox />
            </Box>
            <Box sx={{ width: '100%' }}>
                <ClipTable />
            </Box>
        </Box>
    );
}